// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var InvoiceDraftDetailsController = function ($scope, $http, $routeParams, $location, InvoiceDraft, gettext,
                                              gettextCatalog, $sce, Contract, Customer) {
    var sendClicked = false;
    InvoiceDraft.get({ invoiceDraftId: $routeParams.invoiceDraftId }, function (draft) {
        $scope.customer = Customer.get({ customerId: draft.CustomerId });
        
        angular.forEach(draft.ItemList, function (value) {
            if (value.ProductDescription) {
                value.ProductDescription = value.ProductDescription.replace(/(\r\n)+/ig, '\<br/\>');
                value.ProductDescription = $sce.trustAsHtml(value.ProductDescription);
            }
        });

        $scope.draft = draft;
        $scope.sign = draft.IsInvoice ? +1 : -1;

        Contract.get({ contractId: draft.ContractId }, function (contract) {
            $scope.canBeCorrected = !contract.CustomerIsLocked && !contract.WriteOff;
        });
    });

    $http({
        method: "GET",
        url: "/api/v1/legalEntity/isExtendedLineItemInformation",
        params: null,
        data: null,
        headers: {},
        cache: false
    }).then(function (response) {
        $scope.showExtendedBookedQuantityInformation = response.data;
    });

    //$scope.showExtendedBookedQuantityInformation = IsExtendedLineItemInformation;

    $scope.save = function () {
        $scope.draft.$update({ invoiceDraftId: $routeParams.invoiceDraftId }, function () {
            $location.path("/documents/invoices-credit-notes-drafts");
        });
    };
    $scope.archiveInvoice = function (draftId) {
        $scope.yesCancel(
            gettextCatalog.getString(gettext('Archive Invoice Draft')),
            gettextCatalog.getString(gettext("When archiving the draft, it won't be sent, but it is still counted in the customer's ledger. Also, removing the draft doesn't countermand the payment. Are you sure you want to archive this draft?")),
            function () { $scope.draft.$remove({ invoiceDraftId: $routeParams.invoiceDraftId }, function () { $location.path("/invoice-drafts/"); }); });
    };
    $scope.sendInvoice = function (draftId) {
        if (sendClicked)
            return;
        sendClicked = true;
        $scope.draft.$update({ invoiceDraftId: $routeParams.invoiceDraftId }, function () {
            $http({
                method: "POST", url: "/api/v1/InvoiceDrafts/" + draftId, params: null,
                data: {},
                headers: {},
                cache: false
            }).then(function (response) {
                var invoiceId = response.data.Id;
                $location.path("/invoices/" + invoiceId);
            }, function () {
                sendClicked = false;
            });
        });
        return true;
    };

    $scope.backHistory = function () {
        window.history.back();
    }
};
InvoiceDraftDetailsController.$inject = ['$scope', '$http', '$routeParams', '$location', 'InvoiceDraft',
    'gettext', 'gettextCatalog', '$sce', 'Contract', 'Customer'];
